import {
  SEEK_BAR_HEIGHT_LARGE,
  SEEK_BAR_HEIGHT_MEDIUM,
  SEEK_BAR_HEIGHT_SMALL
} from '../../../../common/utils/common.constants';
import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface StylesObject {
  clickableStoryWrapperStyle: { [key: string]: any };
  storyStyle: { [key: string]: any };
}

const clickableStoryWrapper = {
  flexGrow: '1',
  display: 'flex',
  alignItems: 'center',
  height: '20px',
};

const storyBar = {
  width: '100%',
  flexDirection: 'row',
  background: 'rgba(255, 255, 255, 0.4)',
  borderRadius: '2px',
  small: {
    height: `${SEEK_BAR_HEIGHT_SMALL}px`,
    borderRadius: '1.5px',
  },
  medium: {
    height: `${SEEK_BAR_HEIGHT_MEDIUM}px`,
    borderRadius: '1.5px',
  },
  largeAndExtraLarge: {
    height: `${SEEK_BAR_HEIGHT_LARGE}px`,
  },
};

export const getStorySeekBarsStyleObject = (playerSize: PlayerSizesTypes): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeAndExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';

  return ({
    clickableStoryWrapperStyle: {
      ...clickableStoryWrapper,
    },
    storyStyle: [
      storyBar,
      smallSize && storyBar.small,
      mediumSize && storyBar.medium,
      largeAndExtraLargeSize && storyBar.largeAndExtraLarge,
    ],
  });
};
